module.exports = "\n<app-header></app-header>\n<router-outlet></router-outlet>\n"